export default {
  getSafeColor(value, fallback = '#2096f8') {
    if (typeof value !== 'string' || value.length > 40) return fallback;

    const syntaxIsSafe =
      /^(?:#[\da-f]{3,4}|#[\da-f]{6}|#[\da-f]{8}|rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(?:,\s*(?:0|1|0?\.\d+)\s*)?\)|[a-zA-Z]{3,20})$/i.test(
        value,
      );
    if (!syntaxIsSafe) return fallback;

    // Reject syntactically harmless strings that are not actual CSS colors
    // (for example, "colorembed"), so they cannot invalidate themed styles.
    return typeof CSS !== 'undefined' && CSS.supports('color', value) ? value : fallback;
  },
  buildIcons(files) {
    return files.map(f => {
      switch (f.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/svg+xml':
          f.icon = 'file-image';
          break;
        case 'application/zip':
          f.icon = 'file-archive';
          break;
        case 'application/octet-stream':
          f.icon = 'file-excel';
          break;
        case 'video/mp4':
          f.icon = 'file-video';
          break;
        case 'application/pdf':
          f.icon = 'file-pdf';
          break;
        case 'application/msword':
          f.icon = 'file-word';
          break;
        default:
          f.icon = 'file';
      }
      return f;
    });
  },
  getMaterialColor() {
    // colors from https://github.com/egoist/color-lib/blob/master/color.json

    var colors = [
      '#1abc9c',
      //Blues
      '#3498db',

      //Purples + Pinks
      '#9b59b6',
    ];
    return colors;
  },
  getDateLive(date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return (date = yyyy + '-' + mm + '-' + dd);
  },
};



// WEBPACK FOOTER //
// ./src/helpers/common.js